import React, { useState, useEffect } from "react";
import DataTable from 'react-data-table-component';
import { Button, Modal, Form } from 'react-bootstrap';
import { getAllEmployees, getActiveEmployees, deleteEmployee } from "../../services/EmployeesService";
import { getVacationsSummary } from "../../services/VacationHistoryService";
import Loader from "../common/Loader";
import EmployeeVacations from "./EmployeeVacations";
import FilterComponent from "./FilterComponent";

const EmployeeList = () => {

    const [users, setUsers] = useState([]);
    const [userId, setUserId] = useState(null);
    const [name, setName] = useState(null);
    const [pending, setPending] = useState(true);
    const [filterText, setFilterText] = useState('');
	const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [userToDelete, setUserToDelete] = useState("");
    const [showAllUsers, setShowAllUsers] = useState(false);

    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

	const filteredItems = users.filter(
		item => item.name && item.name.toLowerCase().includes(filterText.toLowerCase()),
	);

    const showDeactivateUsers = () => {
        setShowAllUsers((prevChecked) => !prevChecked);
        setPending(true);
    }

	const subHeaderComponentMemo = React.useMemo(() => {
		const handleClear = () => {
			if (filterText) {
				setResetPaginationToggle(!resetPaginationToggle);
				setFilterText('');
			}
		};

		return (
            <div className='rowC'>
                <Form>
                    <Form.Check // prettier-ignore
                        type="switch"
                        id="custom-switch"
                        label="Mostrar empleados desactivados"
                        onChange={showDeactivateUsers}
                    />
                </Form>
			    <FilterComponent onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} placeholder="Filtrar por nombre..." data-testid="filterInput"/>
            </div>
		);
	}, [filterText, resetPaginationToggle]);

    const showData = async () => {

        let users = []
        if(showAllUsers) {
            users = await getAllEmployees();
        } else {
            users = await getActiveEmployees();
        }
        let data = [];
        for (const key in users) {
            const summary = await getVacationsSummary(users[key].id.toString(), new Date().getFullYear()); 
            data.push({
                id: users[key].id,
                name: users[key].name,
                last_name: users[key].last_name,
                email: users[key].email,
                responsible: users[key].responsible,
                total_days: summary.available_days,
                used_days: summary.approved_days,
                pending_days: summary.pending_days
            })
        }
        return data;
    }

    const handleRowClick = (row) => {
        setUserId(row.id);
        setName(row.name+' '+row.last_name);
    }

    const handleBackClick = () => {
        setUserId(null);
        setName(null);
    }

    useEffect(() => {
        (async () => {
            const data = await showData();
            if (data) {
                setUsers(data);
            }
            setPending(false);
        })();
    }, [showAllUsers])

    const columns = [
        {
            name: 'Id',
            selector: row => row.id
        },
        {
            name: 'Nombre',
            selector: row => row.name + ' ' + row.last_name
        },
        {
            name: 'Email',
            selector: row => row.email
        },
        {
            name: 'Responsable',
            selector: row => row.responsible
        },
        {
            name: 'Días totales',
            selector: row => row.total_days
        },
        {
            name: 'Días aprobados',
            selector: row => row.used_days
        },
        {
            name: 'Días pendientes',
            selector: row => row.pending_days
        },
        {
            name: '',
            button: true,
            cell: row => (
                <div>
                    <Button variant="outline-danger" onClick={() => {
                        setUserToDelete(row.id);
                        setName(row.name + " " + row.last_name);
                        handleShow();
                    }}>Borrar</Button>
                </div>
            ),
        },
    ]

    return (
        <div>
            {userId ? (
                <div>
                    <div className="container">
                        <div className="container-fluid title">
                            <div className="row">
                                <div className="col-md-3">
                                <a onClick={handleBackClick} style={{cursor: "pointer", color: "blue"}}><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"></path>
                                </svg>
                                    
                                Listado de usuarios
                                </a>
                                </div>
                                <div className="col-md-9">
                                    <h3>{name}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <EmployeeVacations userId={userId}/>
                </div>
            ) : (
                <div className="container">
                    <div className="row align-items-center my-5">
                        <h1 className="font-weight-light">Lista de empleados</h1>
                        <div className="App table">
                            <DataTable
                                columns={columns}
                                data={filteredItems}
                                striped={true}
                                progressPending={pending}
                                progressComponent={<Loader />}
                                subHeader
                                subHeaderComponent={subHeaderComponentMemo}
                                persistTableHead
                                onRowClicked={handleRowClick}
                            />
                        </div>
                        <Modal show={showModal} onHide={handleClose}>
                            <div>
                                <Modal.Body>
                                <p>¿Estás seguro de que quieres desactivar a {name}?</p>
                                </Modal.Body>
                                <Modal.Footer>
                                <Button variant="outline-danger" onClick={() => {
                                    deleteEmployeeById(userToDelete);
                                }}>Desactivar</Button>
                                <Button variant="outline-dark" onClick={handleClose}>Cancelar</Button>
                                </Modal.Footer>
                            </div>
                        </Modal>
                    </div>
                </div>
            )}
        </div>
    );
}

const deleteEmployeeById = async (id) => {   
    let formData = {
        user_id: id
    }
    await deleteEmployee(JSON.stringify(formData));
    await window.location.reload();
}

export default EmployeeList;